import React from 'react';

type Props = {
    className?: string;
    isLoading: boolean;
    children: React.ReactNode;
};

export default function Loading({ className, isLoading, children }: Props) {
    if (isLoading) {
        return (
            <div
                className={`animate-pulse bg-[#464444] w-full h-6 rounded-md ${className} `}
            />
        );
    }

    return children;
}
